import { AgentProfile } from "@closerplatform/spinner-openapi";
import { ClickAwayListener } from "@fidget/common/components/form/clickAwayListener";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { logger } from "@fidget/common/utils";
import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { AdviserPicker } from "../../../../components/forms/adviserPicker/adviserPicker";
import { useStore } from "../../../../models";
import { useAgentServices } from "../../../../models/agentServices";
import { GlobalFilterTypes, IFilterAssignee } from "../../../../models/inbox/ConcreteGlobalFilters";
import styles from "../expandedFilters.css";

interface Props {
  resetState(): void;
}

export const AssigneeFilter = observer(({ resetState }: Props) => {
  const { spinnerService } = useAgentServices();
  const { inboxStore, agentStore } = useStore();
  const [isPickingAssignee, setIsPickingAssignee] = useState(false);
  const [agents, setAgents] = useState<Array<AgentProfile>>();

  const filter = inboxStore.globalFilter.getFilter(GlobalFilterTypes.Assignee);
  const pickedAgent = filter
    ? agentStore.getOrLoad((filter as IFilterAssignee).assigneeId)
    : undefined;

  const showAssigneeDropdown = async () => {
    if (!agents) {
      try {
        const values = await spinnerService.getActiveAgentProfiles();

        setAgents(values);
      } catch (error) {
        logger.error({ message: "Couldn't get agent profiles", error });
      }
    }

    setIsPickingAssignee(true);
  };

  const handleClicked = () => {
    if (!isPickingAssignee) {
      if (pickedAgent) {
        inboxStore.globalFilter.deactivateFilter(GlobalFilterTypes.Assignee);
      } else {
        showAssigneeDropdown();
      }
    }
  };

  const handleAgentChosen = (agentId: string) => {
    inboxStore.globalFilter.activateAssigneeFilter(agentId);
    resetState();
  };

  const renderAssigneePicker = (values: AgentProfile[]) => {
    return (
      <ClickAwayListener
        onClickAway={() => setIsPickingAssignee(false)}
        className={styles["tag-picker-container"]}
      >
        <AdviserPicker
          initialIsOpen
          onStateChange={(_, state) => !state.isOpen && setIsPickingAssignee(false)}
          placeholder={intl.formatMessage("inbox.moreFilters.global.adviser")}
          values={values}
          onChange={(agent) => handleAgentChosen(agent.id)}
        />
      </ClickAwayListener>
    );
  };

  return (
    <>
      <div
        className={classNames(styles["entry-container"], { [styles.selected]: !!filter })}
        onClick={handleClicked}
      >
        {isPickingAssignee && agents ? (
          renderAssigneePicker(agents)
        ) : (
          <>
            <div>
              <L10n id="inbox.moreFilters.global.adviser" />
              {pickedAgent && (
                <p className={styles["entry-desc"]}>
                  {pickedAgent.firstName} {pickedAgent.lastName}
                </p>
              )}
            </div>
            {filter && (
              <div className={styles.applied}>
                <L10n id={"inbox.moreFilters.applied"} />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
});
